export const CURRENT_STUDENT_COURSE_ID_KEY = "currentStudentCourseId";
